import { apolloClient } from '@/plugins/apollo';
import { PublishRevision } from '@/graphql';
import { Revision } from '@/models';

const actions = {
  async publish(context, { revision, outcome }) {
    const response = await apolloClient.mutate({
      mutation: PublishRevision,
      variables: {
        revisionId: revision.id,
        outcome,
      },
      refetchQueries: ['GetRevisionsByReviewId'],
    });
    return new Revision(response.data.publishRevision);
  },
};

export default {
  namespaced: true,
  actions,
};
